import { Button, Input, Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const CustomAmountWrapper = styled.div`
  ${Button.S.Button} {
    margin-bottom: var(--size-4);
  }

  ${Input.S.Input} {
    padding-left: var(--size-16);
    width: fit-content;
  }
`;

const CustomAmountInputWrapper = styled.div`
  align-items: center;
  display: flex;
  position: relative;

  ${Typography.S.Typography} {
    left: var(--size-8);
    position: absolute;
  }
`;

const ActionButton = styled.button`
  align-items: center;
  background: var(--color-bg-body);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  box-shadow: var(--shadow-s);
  color: var(--color-accent-secondary-default);
  cursor: ${({ disabled }) => (disabled ? `not-allowed` : `pointer`)};
  display: flex;
  height: 28px;
  justify-content: center;
  margin-left: 3px;
  width: 28px;

  &:first-of-type {
    margin-left: 8px;
  }

  ${({ disabled }) => (disabled ? `opacity: 0.5;` : '')};

  svg path {
    fill: ${({ disabled }) => (disabled ? `var(--color-accent-secondary-default)` : '')};
  }
`;

export { ActionButton, CustomAmountInputWrapper, CustomAmountWrapper };
